/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import { withRouter } from "react-router-dom";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Grid,
  Button,
  Typography,
  Divider,
  Paper,
  Card,
  CardHeader,
  CardContent,
  Chip,
  Tooltip,
  IconButton,
} from "@material-ui/core";

import CheckCircleOutlined from "@material-ui/icons/CheckCircleOutlined";
import HighlightOff from "@material-ui/icons/HighlightOff";
import Add from "@material-ui/icons/Add";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Refresh from "@material-ui/icons/Refresh";
import AutoRenew from "@material-ui/icons/Autorenew";
import AutorenewTwoToneIcon from "@material-ui/icons/AutorenewTwoTone";
import EditOutlined from "@material-ui/icons/EditOutlined";
import SyncAlt from "@material-ui/icons/SyncAlt";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import DynamicFeedIcon from "@material-ui/icons/DynamicFeed";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import UpdateIcon from "@material-ui/icons/Update";

import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../../tableIcons";

import Actions from "../../../fluid/Actions/ActionFactory";

const styles = (theme) => ({});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    // primary: {
    //     main: "#FF6600",
    //     contrastText: "#FFFFFFFF"
    // },
    secondary: {
      main: "#ff9100",
    },
  },
});

class FinishSecurityAdaptorSetup extends Component {
  state = {
    security_adaptor_data: [],
  };

  componentDidMount() {
    console.log("props in proceed to finish")
    console.log(this.props)
    Actions("http_request", {
        url: "/sainapse/security_adapter/" + this.props.security_adaptor_name,
        method: "get",
        data: {},
    }).then((res) => {
        console.log("API Success: ", res.data.result);
        let result = res.data.result;
        let security_adaptor_data = [result]
        this.setState(
          { ...this.state, security_adaptor_data: security_adaptor_data, data_received: true },
          () => console.log("Finish setup State: ", this.state)
        );
    });
    
  }

  renderSecurityAdaptorDetails = () => {
    return (
      <Paper
        variant="outlined"
        style={{
          backgroundColor: "#FAFBFC",
          marginTop: "10px",
          padding: "10px",
        }}
      >
        {/* <Typography variant="overline">Information Units</Typography> */}
        {this.renderSecurityAdaptorTable()}
      </Paper>
    );
  };

  
  renderSecurityAdaptorTable = () => {
    return (
      <MaterialTable
        title="Security Adaptor Summary"
        icons={table_icons}
        columns={[
          { title: "Name", field: "name" },
          {
            title: "Key",
            field: "key",
            render: (rowData) => {
              return (
                <Chip
                  size="small"
                  style={{ backgroundColor: "#2296f3", color: "#FFFFFF" }}
                  label={rowData.key}
                />
              );
            },
          },
          // {title : 'Type', field : 'type', render : rowData => {
          //     return  (
          //         <Chip size = 'small' style = {{backgroundColor : '#2296f3', color : '#FFFFFF' }} label = {rowData.type}/>
          //     )
          // }},
          {
            title: "Security Adaptor Parameters",
            field: "params",
            render: (rowData) => {
              if (rowData.params === null) {
                return (
                  <HighlightOff fontSize="small" style={{ color: "#f44336" }} />
                );
              } else {
                return (
                  <CheckCircleOutlined
                    fontSize="small"
                    style={{ color: "#4caf50" }}
                  />
                );
              }
            },
          },
          
        ]}
        data={this.state.security_adaptor_data}
        options={{
          search: false,
          toolbar: false,
          showTitle: false,
          paging: false,
        }}
      />
    );
  };

  renderExit = () => {
    return (
      <ThemeProvider theme={blue_theme}>
        <Button
          style={{ marginTop: "10px", marginBottom: "10px" }}
          variant="contained"
          color="primary"
          fullWidth
          onClick={this.exitSetup}
        >
          Finish & Exit Setup
        </Button>
      </ThemeProvider>
    );
  };

  renderContent = () => {
    if (this.state.data_received === true) {
      return (
        <div>
          
          {this.renderSecurityAdaptorDetails()}
          {this.renderExit()}
        </div>
      );
    } else {
      return (
        <Typography variant="body2" color="textSecondary">
          <em>Fetching Security Adaptor Data</em>
        </Typography>
      );
    }
  };

  exitSetup = () => {
    Actions("http_request", {
        url: "/sainapse/security_adapter/" + this.props.security_adaptor_name + "/setup_complete",
        method: "post",
        data: true,
        headers : {
            'Content-Type' : 'application/json'
        }
    }).then((res) => {
        console.log("API Success: ", res.data.result);
        this.props.closePopup();
    });   
  };

  render() {
    const { classes } = this.props;
    return (
      <div
        style={{
          width: "100%",
          maxHeight: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          overflow: "scroll",
        }}
      >
        <Card style={{ width: "75%", margin: "8px" }}>
          <CardHeader
            title={this.props.security_adaptor_name}
            subheader="Security Adaptor"
            titleTypographyProps={{
              variant: "button",
            }}
            subheaderTypographyProps={{
              variant: "overline",
            }}
            // action = {
            //     <Fragment>
            //         <ThemeProvider theme = {blue_theme}>
            //             <Tooltip title = "Train">
            //                 <IconButton size = 'medium' color = 'primary'>
            //                     <AutorenewTwoToneIcon />
            //                 </IconButton>
            //             </Tooltip>
            //         </ThemeProvider>
            //     </Fragment>
            // }
          />
          <CardContent>{this.renderContent()}</CardContent>
        </Card>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(FinishSecurityAdaptorSetup));
